import { render, staticRenderFns } from "./componentSuffix.vue?vue&type=template&id=5dd3e00b&"
import script from "./componentSuffix.vue?vue&type=script&lang=js&"
export * from "./componentSuffix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports